import React from "react";

interface ContentWrapperProps {
  children: React.ReactNode;
  onClick?: () => void;
  isHoverable?: boolean;
}

export const ContentWrapper: React.FC<ContentWrapperProps> = ({
  children,
  onClick,
  isHoverable = false,
}) => {
  return (
    <div
      className={`p-[12px] bg-[#18181C] ${
        isHoverable ? "transition-colors duration-200 hover:bg-[#292930]" : ""
      }`}
      onClick={onClick}
      style={{ cursor: onClick ? "pointer" : "default" }}
    >
      {children}
    </div>
  );
};
